/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_3_AnswerInputs */

const en_svc_rag_faq_3_answer = /** @type {(inputs: Svc_Rag_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data handling — which provider, where data is stored, and whether it may be used for training — is agreed in writing before implementation. By default we choose settings that keep your documents out of model training.`)
};

const lv_svc_rag_faq_3_answer = /** @type {(inputs: Svc_Rag_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datu apstrāde — kurš pakalpojumu sniedzējs, kur dati glabājas un vai tos drīkst izmantot apmācībai — tiek saskaņota rakstiski pirms ieviešanas. Pēc noklusējuma izvēlamies iestatījumus, kas Jūsu dokumentus neizmanto modeļu apmācībai.`)
};

/**
* | output |
* | --- |
* | "Data handling — which provider, where data is stored, and whether it may be used for training — is agreed in writing before implementation. By default we cho..." |
*
* @param {Svc_Rag_Faq_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_3_answer = /** @type {((inputs?: Svc_Rag_Faq_3_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_3_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_3_answer(inputs)
	return en_svc_rag_faq_3_answer(inputs)
});